module.exports = __webpack_public_path__ + "img/img92.5d799cc2.jpg";